export const getUserId = () => localStorage.getItem("fpg_userId");
